import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {DialogService, UserService} from "@wms/services";
import {environment} from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {

  private status: Subject<boolean> = new Subject();
  private status$: Observable<boolean> = this.status.asObservable();
  private isLoginInProgress: boolean = false;
  constructor(private dialogService: DialogService, private userService: UserService) { }

  /**
   * returns true if a user already exists. Only in this case it is actually a session time out
   * else returns false, this is when user never logged in and trying to access studio
   */
  isSessionTimeout() {
    return !!this.userService.get();
  }

  /**
   * calls login dialog
   * returns an observable
   * the observable will be completed once the login flow is complete
   */
  handleSessionTimeout(): Observable<any> {
    if (this.isLoginInProgress) {
      return this.status$;
    }
    this.isLoginInProgress = true;

    // If session exists, login through session timeout dialog
    // else if prod env, redirect to login page
    // else, local setup, login through prompt
    // not able to use session timeout dialog in this case, as app is not yet bootstrapped
    // should implement a login page for local dev for this case

    this.userService.isFormLogin()
      .then((response)=> {
        if (this.isSessionTimeout()) {
          if (response.result) {
            this.dialogService.open('sessionTimeoutDialog');
          } else {
            this.dialogService.open('ssoSessionTimeoutDialog');
          }
        } else if (environment.production) {
          window.location.href = '/login';
        } else {
          this.handleLoginWithPrompt();
        }
      });
    return this.status$;
  }

  /**
   * temp logic for local dev
   * should be removed once login page is implemented
   */
  handleLoginWithPrompt() {
    let data:any = window.prompt("username and password (space separated)") || '';
    data = data.split(' ');
    data = {"email": data[0], "password": data[1]};
    this.userService.login(data)
      .then(()=>{
        this.markLoginSuccess();
      });
    return this.status$;
  }

  /**
   * completes the observable
   * so that the listener can continue post login flow
   */
  markLoginSuccess() {
    this.isLoginInProgress = false;
    this.status.next(true);
  }

}
